export { default as VehicleSedanIcon } from "./VehicleSedanIcon";
export { default as VehicleTruckIcon } from "./VehicleTruckIcon";
export { default as VehicleSuvIcon } from "./VehicleSuvIcon";
export { default as VehicleCoupeIcon } from "./VehicleCoupeIcon";
export { default as VehicleConvertibleIcon } from "./VehicleConvertibleIcon";
export { default as VehicleWagonIcon } from "./VehicleWagonIcon";
export { default as VehicleHatchbackIcon } from "./VehicleHatchbackIcon";
export { default as VehicleMinivanIcon } from "./VehicleMinivanIcon";
